module.exports = __webpack_public_path__ + "static/img/4核心算法-on.527541d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/4核心算法-on.png
// module id = vgdx
// module chunks = 0